import { ResponsePayload } from "@/types/model";
import { getData } from "../base.ehq.model";
import { deserialize } from "../base.serializer";

export const getStaticPage = async (
  token: string,
  baseUrl: string,
  permalink: string,
  params?: object,
  config?: object
) => {
  const queryPath = `${baseUrl}/static_pages/${permalink}`;
  return await getData(token, queryPath, params, config).then(
    (response: ResponsePayload) => deserialize(response.data)
  );
};
